import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
// import '@shopify/polaris/styles.css';
import '@shopify/polaris/dist/styles.css';
import './i18n';
import App from './App';
import Welcome from './unlogin/Welcome';
import * as serviceWorker from './serviceWorker';
import {onCLS, onFID, onLCP} from 'web-vitals';

const isProduction = (process.env.NODE_ENV === 'production')
const urlParams = new URLSearchParams(window.location.search)
const shop = urlParams.get("shop")

if(shop && shop !== "" && urlParams.get("code") && urlParams.get("code") !== "" && isProduction) {
  ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root')
  );
} else {
  if(isProduction) {
    ReactDOM.render(
      <React.StrictMode>
        <Welcome />
      </React.StrictMode>,
      document.getElementById('root')
    );
  } else {
    ReactDOM.render(
      <React.StrictMode>
          <App />
      </React.StrictMode>,
      document.getElementById('root')
    );
  }
}

onCLS(console.log);
onFID(console.log);
onLCP(console.log);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
